<div part="cm-config-menu-icons" class="cm-config-menu-icons" style="--icon-size: {{ $iconSize() + 'px' }}">
    @if ($isStepThrough()) {
        @let item = $stepThroughActiveItem();
        @if (item) {
            <div part="cm-config-group-title cm-config-group-title-step-through" class="cm-config-group-title cm-config-group-title-step-through">
                @if ($stepThroughHasPrev()) {
                    <i part="cm-config-group-back" class="far fa-chevron-left" (click)="stepThroughPrev()"></i>
                }
                <span>
                    {{ item.config.props.name }}
                </span>
                @if ($stepThroughHasNext()) {
                    <i part="cm-config-group-forward" class="far fa-chevron-right" (click)="stepThroughNext()"></i>
                }
            </div>
            <ng-container *ngTemplateOutlet="configVariants; context: {$implicit: item.config}"></ng-container>
        }
    } @else {
        @let isStepInto = $isStepInto();
        @let stepIntoConfigId = $stepIntoActiveId();
        @for (entry of $entries(); track entry.kind === "section" ? "section:" + entry.title : "item:" + entry.config.props.id) {
            @if (entry.kind === "section") {
                @switch (sectionRenderMode(entry)) {
                    @case ("full") {
                        <ng-container *ngTemplateOutlet="sectionTitle; context: {$implicit: entry}"></ng-container>
                        <div part="cm-config-section" class="cm-config-section" [class.cm-config-section-flush]="isStepInto">
                            @for (desc of entry.configs; track desc.props.id) {
                                <ng-container *ngTemplateOutlet="configBlock; context: {$implicit: desc}"></ng-container>
                            }
                        </div>
                    }
                    @case ("title-only") {
                        <ng-container *ngTemplateOutlet="sectionTitle; context: {$implicit: entry}"></ng-container>
                    }
                    @case ("config-only") {
                        @for (desc of entry.configs; track desc.props.id) {
                            @if (stepIntoConfigId === desc.props.id) {
                                <ng-container *ngTemplateOutlet="configBlock; context: {$implicit: desc}"></ng-container>
                            }
                        }
                    }
                }
            } @else {
                @if (isUngroupedConfigVisible(entry.config.props.id)) {
                    <ng-container *ngTemplateOutlet="configBlock; context: {$implicit: entry.config}"></ng-container>
                }
            }
        }
    }
</div>

<ng-template #sectionTitle let-entry>
    @let isSectionEntered = $isStepInto() && $stepIntoActiveSectionTitle() === entry.title;
    @let isSectionOpen = $openSectionTitles().has(entry.title);
    <div
        [attr.part]="
            isSectionEntered
                ? 'cm-config-section-title cm-config-section-title-stepped-into'
                : !$isStepInto() && $uiStyle() === 'accordion' && isSectionOpen
                  ? 'cm-config-section-title cm-config-section-title-active'
                  : 'cm-config-section-title'
        "
        class="cm-config-section-title"
        [ngClass]="{
            'cm-config-section-title-accordion': $uiStyle() === 'accordion',
            'cm-config-section-title-stepped-into': isSectionEntered,
        }"
        (click)="onSectionClicked(entry.title)"
    >
        @if (isSectionEntered) {
            <i part="cm-config-section-back" class="far fa-chevron-left"></i>
        }
        <span>{{ entry.title }}</span>
        @if ($uiStyle() === "accordion" && !$isStepInto()) {
            <i
                [attr.part]="isSectionOpen ? 'cm-config-section-toggle cm-config-section-toggle-open' : 'cm-config-section-toggle'"
                [ngClass]="isSectionOpen ? 'far fa-chevron-up' : 'far fa-chevron-down'"
            ></i>
        }
        @if ($isStepInto() && !isSectionEntered) {
            <i part="cm-config-section-forward" class="far fa-chevron-right"></i>
        }
    </div>
</ng-template>

<ng-template #configBlock let-desc>
    @let isConfigStepped = $isStepInto() && $stepIntoActiveId() === desc.props.id;
    @let isConfigOpen = $selectedDescriptorIds().has(desc.props.id);
    <div
        [attr.part]="
            isConfigStepped
                ? 'cm-config-group-title cm-config-group-title-stepped-into'
                : isConfigOpen && $uiStyle() === 'accordion'
                  ? 'cm-config-group-title cm-config-group-title-active'
                  : 'cm-config-group-title'
        "
        class="cm-config-group-title"
        [ngClass]="{
            'cm-config-group-title-accordion': $uiStyle() === 'accordion',
            'cm-config-group-title-stepped-into': isConfigStepped,
        }"
        (click)="onDescriptorClicked(desc.props.id)"
    >
        @if (isConfigStepped) {
            <i part="cm-config-group-back" class="far fa-chevron-left"></i>
        }
        <span>{{ desc.props.name }}</span>
        @if ($uiStyle() === "accordion" && !$isStepInto()) {
            <i
                [attr.part]="isConfigOpen ? 'cm-config-group-toggle cm-config-group-toggle-open' : 'cm-config-group-toggle'"
                [ngClass]="isConfigOpen ? 'far fa-chevron-up' : 'far fa-chevron-down'"
            ></i>
        }
        @if ($isStepInto() && !isConfigStepped) {
            <i part="cm-config-group-forward" class="far fa-chevron-right"></i>
        }
    </div>

    @if ($uiStyle() === "icons" || isConfigOpen) {
        <ng-container *ngTemplateOutlet="configVariants; context: {$implicit: desc}"></ng-container>
    }
</ng-template>

<ng-template #configVariants let-desc>
    <div
        [attr.part]="desc.props.displayWithLabels ? 'cm-labels-container' : 'cm-icons-container'"
        [ngClass]="desc.props.displayWithLabels ? 'cm-labels-container' : 'cm-icons-container'"
    >
        @for (variant of desc.props.variants; track variant.id) {
            <cm-config-button
                [asLabel]="desc.props.displayWithLabels"
                [tooltipContainer]="$tooltipContainer()"
                [config]="desc"
                [variant]="variant"
                [useCaptions]="$useCaptions()"
                [selectedVariant]="desc?.props?.value ?? undefined"
                (click)="configMenuService.emitConfigSelected({config: desc, variant})"
            ></cm-config-button>
        }
    </div>
</ng-template>
